var jcsfApp;
(function (jcsfApp) {
	var app;
	(function (app) {
		var auth;
		(function (auth) {
			var indexController = (function () {
				function indexController(
					$location,
					authService,
					permissionService,
					$scope
				) {
					authService.fillAuthData();
					this.$location = $location;
					this.authService = authService;
					this.permissionService = permissionService;
					this.authentication = this.authService.authentication;

					this.logOut = function () {
						document.cookie = 'Shim=;expires=Thu, 01 Jan 1970 00:00:01 GMT';
						this.authService.LogoutData(
							this.authService.authentication.userInfo
						);
						$scope.$state.go('home');
						this.permissionService.setPermissions([]);
						this.authService.logOut();
					};
				}

				indexController.prototype.isInRole = function (role) {
					return this.permissionService.hasPermission(role);
				};
				indexController.$inject = [
					'$location',
					'authService',
					'PermissionService',
					'$scope',
				];
				return indexController;
			})();

			angular.module('jcsfApp').controller('IndexController', indexController);
		})((auth = app.auth || (app.auth = {})));
	})((app = jcsfApp.app || (jcsfApp.app = {})));
})(jcsfApp || (jcsfApp = {}));
